<template>
  <div class="float mt-1 ml-2 mr-2">
    <b-button variant="primary" class="mb-2 ml-3" @click="loadData" size="sm">
      Refresh</b-button
    >
    <b-input-group size="sm" prepend="Nama File" class="mt-1 col-4">
      <template #prepend>
        <span class="input-group-text" style="width: 120px">Nama File</span>
      </template>
      <b-form-input v-model="fl"></b-form-input
    ></b-input-group>
    <b-input-group size="sm" prepend="Primary Key" class="mt-1 col-4">
      <template #prepend>
        <span class="input-group-text" style="width: 120px">Primary Key</span>
      </template>
      <b-form-input v-model="pk" disabled></b-form-input
    ></b-input-group>
    <b-input-group size="sm" prepend="Daftar Field" class="mt-1 mb-2 col-12">
      <template #prepend>
        <span class="input-group-text" style="width: 120px">Daftar Field</span>
      </template>
      <b-form-input v-model="field"></b-form-input
    ></b-input-group>
    <div class="row ml-1">
      <b-input-group size="sm" prepend="Filter-1" class="mt-1 mb-2 col-4">
        <b-form-select :options="fields2" v-model="filterfield"></b-form-select>
        <b-form-input v-model="filter"></b-form-input>
      </b-input-group>
      <b-input-group size="sm" prepend="Filter-2" class="mt-1 mb-2 col-4">
        <b-form-select
          :options="fields2"
          v-model="filterfield2"
        ></b-form-select>
        <b-form-input v-model="filter2"></b-form-input>
        <div class="mt-1 ml-2">#{{ siswa.length }}</div>
      </b-input-group>
    </div>
    <b-table
      :items="siswa"
      :fields="fields"
      @row-clicked="setEditableRow"
      hover
      small
      responsive
      style="font-size: 12px"
    >
      <template #cell()="{ item, field }">
        <div
          v-if="
            editableRow === item[pk] &&
            pk !== field.key &&
            field.key !== 'identify'
          "
        >
          <b-form-input
            v-model="item[field.key]"
            @change="updateData(item, field.key)"
            :type="field.type === 'date' ? 'date' : 'text'"
            size="sm"
          />
        </div>
        <div v-else>
          {{ item[field.key] }}
        </div>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["pk", "fl", "field"],
  data() {
    return {
      siswa: [],
      editableRow: null,
      fields: [],
      fields2: [],
      pkx: "", // primary key
      flx: "", // namafile

      fieldx: "", //daftar list field
      filterfield: "", // field untuk filter
      filterfield2: "", // field untuk filter
      filter: "", // filter value
      filter2: "",
    };
  },
  watch: {
    pk() {
      this.filter = "";
      this.filter2 = "";
      this.filterfield = "";
      this.siswa = [];
    },
    fl() {
      this.filter = "";
      this.filter2 = "";
      this.siswa = [];
      this.filterfield = "";
    },
  },
  methods: {
    setEditableRow(item) {
      this.editableRow = item[this.pk];
    },
    loadData() {
      // this.pk = "nis"; // Primary key for the siswa table
      // var fiel = "nis,nama,alamat,kota,namaayah,namaibu";

      axios
        .get(
          this.$appUrl +
            "ceknamafield.php?nf=" +
            this.fl +
            "&fields=" +
            this.field +
            "&filterfield=" +
            this.filterfield +
            "&filter=" +
            this.filter +
            "&filter2=" +
            this.filter2 +
            "&filterfield2=" +
            this.filterfield2
        )
        .then((res) => {
          this.siswa = res.data.items;
          this.fields = res.data.fields;
          this.fields2 = res.data.fields2;
        });
    },
    updateData(item, field) {
      axios
        .post(
          this.$appUrl +
            "updatetable.php?field=" +
            field +
            "&file=" +
            this.fl +
            "&pk=" +
            this.pk,
          item
        )
        .then(() => {
          this.$bvToast.toast("Data berhasil diperbarui", {
            title: "Sukses",
            variant: "success",
            solid: true,
          });
        })
        .catch(() => {
          this.$bvToast.toast("Gagal memperbarui data", {
            title: "Error",
            variant: "danger",
            solid: true,
          });
        });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.table-fixed-column thead th:first-child,
.table-fixed-column tbody td:first-child {
  position: sticky;
  left: 0;
  background-color: white;
  z-index: 1;
}
</style>
